import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {  MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {  MatSelectModule } from '@angular/material/select';
import {  MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import {  MatSliderModule } from '@angular/material/slider';
import {  MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {  MatTooltipModule } from '@angular/material/tooltip';
import {  MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRippleModule } from '@angular/material/core';
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarModule } from '../shared/lib/ngx-perfect-scrollbar-master/projects/lib/src/public-api';
import { PERFECT_SCROLLBAR_CONFIG } from '../shared/lib/ngx-perfect-scrollbar-master/projects/lib/src/public-api';
import { PerfectScrollbarConfigInterface } from '../shared/lib/ngx-perfect-scrollbar-master/projects/lib/src/public-api';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  imports: [
    CommonModule, MatButtonModule, MatIconModule, MatCardModule,
    MatFormFieldModule, MatInputModule, MatListModule, MatStepperModule,
    MatDatepickerModule, MatPaginatorModule, MatNativeDateModule, MatSelectModule,
    MatChipsModule, MatOptionModule, MatCheckboxModule, MatRadioModule, MatToolbarModule,
    MatTableModule, MatTabsModule, MatTooltipModule, MatProgressSpinnerModule, MatSidenavModule,
    MatAutocompleteModule, MatMenuModule, MatSnackBarModule, MatDialogModule, MatSliderModule,
    MatExpansionModule, MatTreeModule, MatSlideToggleModule, MatProgressBarModule, MatRippleModule, PerfectScrollbarModule
  ],
  exports: [
    MatButtonModule, MatIconModule, MatCardModule, MatFormFieldModule, MatInputModule,
    MatListModule, MatDatepickerModule, MatStepperModule, MatNativeDateModule, MatSelectModule,
    MatChipsModule, MatOptionModule, MatPaginatorModule, MatCheckboxModule, MatRadioModule,
    MatToolbarModule, MatTableModule, MatTabsModule, MatProgressSpinnerModule, MatSidenavModule,
    MatAutocompleteModule, MatMenuModule, MatTooltipModule, MatSnackBarModule, MatDialogModule,
    MatSliderModule, MatExpansionModule, MatTreeModule, MatSliderModule, MatSlideToggleModule, MatButtonToggleModule, MatProgressBarModule,
    MatRippleModule, PerfectScrollbarModule
  ]
})
/**
 *
 * MatButtonModule,
 * MatIconModule,
 * MatCardModule,
 * MatFormFieldModule,
 * MatInputModule,
 * MatListModule,
 * MatDatepickerModule,
 * MatStepperModule,
 * MatNativeDateModule,
 * MatSelectModule,
 * MatChipsModule,
 * MatOptionModule,
 * MatPaginatorModule,
 * MatCheckboxModule,
 * MatRadioModule,
 * MatToolbarModule,
 * MatTableModule,
 * MatTabsModule,
 * MatProgressSpinnerModule,
 * MatSidenavModule,
 * MatAutocompleteModule,
 * MatMenuModule,
 * MatTooltipModule,
 * MatSnackBarModule,
 * MatDialogModule,
 * MatSliderModule,
 * MatExpansionModule,
 * MatTreeModule,
 * MatSliderModule,
 * MatSlideToggleModule,
 * MatButtonToggleModule, MatProgressBarModule
 */
export class MaterialModule { }
